import React from 'react'
import { Container, Row, Col } from "react-bootstrap";

export default function StaggerSection() {

    return (
        <section className='padding-section-large bg-gradient-1'>
            <Container>
                <Row className=''>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">What We <span className="text-gradient-1">Stand By</span></h2>
                        <h5 className='heading-style-h5 pb-5'>Simple principles that guide how we think, build and deliver, every single day. </h5>
                    </Col>
                </Row>
                <Row className="d-flex align-items-stretch stagger-wrapper">
                    <div className="stagger-grid">
                        {/* Card 1 */}
                        <div className="card-box primary-border light-bg logo-bg">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Technical Excellence</h5>
                            <p>
                                We focus on getting things right at the engineering level, not just
                                delivering outcomes
                            </p>
                        </div>

                        {/* Card 2 */}
                        <div className="card-box card-moveBottom">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Offshore Delivery Expertise</h5>
                            <p>
                                Years of experience in building and managing offshore teams with
                                clarity and accountability
                            </p>
                        </div>

                        {/* Card 3 */}
                        <div className="card-box card-2">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Client-Centric Growth</h5>
                            <p>
                                We align our work with what actually moves the business forward, not
                                just technical delivery
                            </p>
                        </div>

                        {/* Card 4 */}
                        <div className="card-box card-moveBottom">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Consistency Over Speed</h5>
                            <p>
                                We prioritise stability and reliability over rushing through delivery
                            </p>
                        </div>

                        {/* Card 5 */}
                        <div className="card-box card-4">
                            <h5 className='heading-style-h5 mb-4 fw-bold'>Ownership in Execution</h5>
                            <p>
                                We take responsibility for how systems perform, not just how they are
                                delivered
                            </p>
                        </div>

                    </div>
                </Row>

            </Container>
        </section>
    );
}
